const defaultEntry = '/app'

const specifierMatchRe =
  /^(?<packageName>(?<scope>@[^/]+)?\/?[^/@]+)(?<entryPath>\/[^@]+)?(@(?<version>.+))?$/

export const parsePackageSpecifier = (specifier = '') => {
  const {
    packageName = specifier,
    scope,
    entryPath: absEntryPath = defaultEntry,
    version,
  } = specifier.match(specifierMatchRe)?.groups || {}

  // tack the relative path-like period onto the entry path
  const entryPath = '.' + absEntryPath

  return {
    entryPath,
    packageName,
    scope,
    version,
  }
}
